import {Component, Input,OnInit} from '@angular/core';
import {ReportService} from 'src/app/services/report.service';
import {MatCheckboxChange} from "@angular/material/checkbox";
import {UserProfile} from '../../../configs/model/user-profile.model';
import {UserProfileService} from "../../../services/user-profile.service";
import {ToolbarService} from "../../../services/toolbar.service";


@Component({
  selector: 'followup-checkbox',
  templateUrl: './followup-checkbox.component.html',
  styleUrls: ['./followup-checkbox.component.scss']
})
export class FollowupCheckboxComponent implements OnInit {

  @Input() reportId;
  reportFollowUp: boolean;
  userProfile: UserProfile;
  isExternalUser: boolean;

  constructor(private baseReportService: ReportService,private userProfileService: UserProfileService, private toolbarService: ToolbarService,) {
    this.userProfile = {} as UserProfile;

    userProfileService.getUserProfile(false).subscribe((userProfile) => {
      this.userProfile = userProfile;
    });
  }

  ngOnInit() {
   this.isExternalUser = this.userProfileService.isExternalUser(this.userProfile);
   this.toolbarService.getCheckboxState.subscribe(flag => {
     this.getFollowUpFlag(flag);
   })
   this.getFollowUpFlag(this.reportId);
  }

  getFollowUpFlag (reportId) {
    if (this.isExternalUser) {
      this.baseReportService.getFollowUpFlag(reportId).subscribe((followUpFlag: boolean) => {
        this.reportFollowUp = followUpFlag;
      })
    }
  }

onChangeToggle(event: MatCheckboxChange) {
    this.reportFollowUp = event.checked;
    const action = this.reportFollowUp ?
      this.baseReportService.setReportFlag(this.reportId) :
      this.baseReportService.unsetReportFlag(this.reportId);

    action.subscribe({
      next: (response) => {
        const message = this.reportFollowUp ?
          `Follow up flag saved ${response}` :
          `Follow up flag for ${this.reportId} removed`;
        console.log(message);
      },
      error: (error) => {
        const action = this.reportFollowUp ? 'setting' : 'removing';
        console.error(`Error ${action} follow up flag:`, error);
      }
    });
}
}
